import { useCallback, useMemo, useState } from "react";
import TableAction from "components/TableAction";
import MDBox from "components/MDBox";
import PersonAddIcon from "@mui/icons-material/PersonAdd";
import { useNavigate } from "react-router-dom";
import CustomMenu from "components/CustomizedMui/CustomMenu";
import { Box, Tooltip, Typography } from "@mui/material";
import { ThumbDown, ThumbUp } from "@mui/icons-material";
import InterviewFeedbackButton from "components/InterviewFeedbackButton";

const MyInterviewsActions = ({
  row,
  onOpenTeamMemberModal,
  onOpenApplicantModal,
  setIsSendMessageModalOpen,
  onOpenMessageMenu,
  onRefresh,
}) => {
  const navigate = useNavigate();

  const onClickHandler = useCallback(
    (action, e) => {
      e.stopPropagation();
      navigate(`/events/${row.eventUrl}/action/eventsinfo`);
    },
    [navigate, row.eventUrl]
  );

  const actions = useMemo(
    () => [
      {
        color: "info",
        icon: "info",
        clickAction: (e) => onClickHandler("interviewInfo", e),
        tooltip: "Interview Info",
      },
      {
        color: "error",
        icon: "people",
        clickAction: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onOpenApplicantModal(row);
        },
        tooltip: (
          <Box>
            {`Interview Applicants${row?.applicants?.length ? ":" : ""}`}
            {row?.applicants?.map((appl) => (
              <>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {`${appl.firstName} ${appl.lastName}`}
                  {appl?.interviews?.[0]?.feedback?.rating === "No" ? (
                    <ThumbDown color="error" sx={{ marginLeft: "4px" }} />
                  ) : null}
                  {appl?.interviews?.[0]?.feedback?.rating === "Yes" ? (
                    <ThumbUp color="success" sx={{ marginLeft: "4px" }} />
                  ) : null}
                  {appl?.interviews?.[0]?.feedback?.rating === "Maybe" ? (
                    <ThumbUp color="warning" sx={{ marginLeft: "4px" }} />
                  ) : null}
                  {!["Yes", "Maybe", "No"].includes(appl?.interviews?.[0]?.feedback?.rating) ? (
                    <ThumbUp color="white" sx={{ marginLeft: "4px" }} />
                  ) : null}
                </Box>
              </>
            ))}
          </Box>
        ),
      },
      {
        color: "warning",
        icon: "diversity_3",
        clickAction: (e) => {
          e.preventDefault();
          e.stopPropagation();
          onOpenTeamMemberModal(row);
        },
        tooltip: (
          <Box>
            {`Interview Team Members${row?.attendees?.length ? ":" : ""}`}
            {row?.attendees?.map((att) => (
              <>
                <Box
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  {`${att.firstName} ${att.lastName}`}
                </Box>
              </>
            ))}
          </Box>
        ),
      },
      {
        color: "violet",
        icon: "email",
        clickAction: (e) => {
          e.stopPropagation();
          onOpenMessageMenu(e, row);
        },
        tooltip: `Send a message`,
        iconStyle: {
          color: "#5f32a2",
        },
      },
    ],
    [onClickHandler, onOpenApplicantModal, onOpenMessageMenu, onOpenTeamMemberModal, row]
  );

  return (
    <MDBox display="flex" justifyContent="end">
      {actions.map((prop) => (
        <TableAction {...prop} />
      ))}
      {!row?.applicants?.length && (
        <TableAction
          {...{
            color: "secondary",
            icon: "thumb_up",
            clickAction: (e) => {
              e.stopPropagation();
            },
            tooltip: `This interview has no applicants`,
            iconStyle: {
              opacity: 0.5,
            },
          }}
        />
      )}
      {row?.applicants?.length > 1 && (
        <TableAction
          {...{
            color: "secondary",
            icon: "thumb_up",
            clickAction: (e) => {
              e.stopPropagation();
            },
            tooltip: `This interview has more than one applicant. Please use the Applicants button to set feedback.`,
            iconStyle: {
              opacity: 0.5,
            },
          }}
        />
      )}
      {row?.applicants?.length === 1 && (
        <InterviewFeedbackButton
          sx={{ paddingTop: 0, paddingBottom: 0 }}
          applicant={row?.applicants[0]}
          // refetchApplicants={refresh}
          onChangeFeedback={onRefresh}
          eventUrl={row?.eventUrl}
          fontSize="large"
          isFinal
        />
      )}
    </MDBox>
  );
};

export default MyInterviewsActions;
